import React from 'react';

export const UserLogin = (props: { login: React.ReactNode; }) => {
    return (
        <div className={'user-item__info'}>
            Last login: {props.login}
        </div>
    )
}
